module.exports = __webpack_public_path__ + "img/undraw_composition_oskp.40661e59.svg";